import { render, staticRenderFns } from "./EvaluationView.vue?vue&type=template&id=3224e866&"
import script from "./EvaluationView.vue?vue&type=script&lang=js&"
export * from "./EvaluationView.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports